var exports = {
  "kL": "xfd349460--827597--container",
  "Qs": "xfd349460--827597--content",
  "u1": "xfd349460--827597--spinner",
};

module.exports = exports;
